import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Info from '@/images/Info.svg';
import Record from '@/images/Record.svg';
import Upload from '@/images/uploadIcon.svg';
import styled from '@emotion/styled';
import { Typography, useTheme } from '@mui/material';
import CloneVoiceOptionButton from './CloneVoiceOptionButton';
import { SubTitle, Title, TitleWithBackButton } from './common';
import { WizardStep } from './types';

const InfoContainer = styled.div`
    background-color: ${({ theme }) => theme.colors.black[100]};
    border-radius: 8px;
    display: flex;
    width: 100%;
    padding: 10px 16px;
    align-items: center;
    gap: var(--1, 8px);
`;

const InfoText = styled(Typography)`
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.28px;
`;

const StyledSubTitle = styled(SubTitle)`
    margin-bottom: 24px;
    margin-top: 10px;
`;

const OptionButtonsContainer = styled.div`
    display: flex;
    gap: 16px;
    margin-top: 16px;
    width: 100%;
    height: 200px;
`;

interface Props {
    onSelect: (nextStep: WizardStep) => void;
    onBack?: () => void;
}

function MainDialogContent({ onSelect, onBack }: Props) {
    const theme = useTheme();

    return (
        <>
            {onBack ? <TitleWithBackButton title="Clone your voice" onBackClick={onBack} /> : <Title variant="h2">Clone your voice</Title>}

            <StyledSubTitle variant="body1">Upload an audio clip or record your own voice.</StyledSubTitle>
            <InfoContainer>
                <MaskedIcon src={Info} size="16px" />
                <InfoText variant="body2">
                    Sample quality is more important than length. Noisy samples may give bad results. <br />
                    Minimum 30 seconds, up to 5 minutes long.
                </InfoText>
            </InfoContainer>
            <OptionButtonsContainer>
                <CloneVoiceOptionButton
                    icon={<img src={Record} width={31} />}
                    title="Record voice"
                    onClick={() => {
                        onSelect?.(WizardStep.Record);
                    }}
                    description={
                        <>
                            Record a short 30 second
                            <br />
                            script to clone your voice
                        </>
                    }
                />
                <CloneVoiceOptionButton
                    icon={<MaskedIcon src={Upload} size="31px" color={theme.colors.secondary[500]} />}
                    title="Upload file"
                    onClick={() => {
                        onSelect?.(WizardStep.Upload);
                    }}
                    description={
                        <>
                            Upload a file from your computer, with the
                            <br />
                            consent script provided in the next step
                        </>
                    }
                />
            </OptionButtonsContainer>
        </>
    );
}

export default MainDialogContent;
